import { useMemo } from 'react';
import { numberFormatter } from '@lib/number-formatting';

export function useSelectTypeTotalInfo(props: IUseSelectTypeTotalInfoProps) {
  const { mapSize, bugsCount, bugsVolume } = props;
  const mapSizeInHa = +((mapSize ?? 0) / 10000).toFixed(2);

  return useMemo(
    () => [
      {
        label: 'размер выделенного на карте поля',
        value: mapSizeInHa
          ? `${numberFormatter({
              source: mapSizeInHa,
              maximumFractionDigits: 2,
            })} Га`
          : '-',
      },
      {
        label: 'максимальная вместимость поля',
        value: bugsCount
          ? numberFormatter({ source: bugsCount, minimumFractionDigits: 0 })
          : '-',
      },
      {
        label: 'объем рукавного фонда',
        value: bugsVolume
          ? numberFormatter({ source: bugsVolume, minimumFractionDigits: 0 }) + `m3`
          : '-',
      },
    ],
    [mapSize, bugsCount, bugsVolume],
  );
}

export interface IUseSelectTypeTotalInfoProps {
  mapSize?: number;
  bugsCount?: number;
  bugsVolume?: number;
}
